export default "__VITE_ASSET__JREVWLJY__"